// extracted by mini-css-extract-plugin
export default {"scorePanel":"account_scorePanel__PFZUM","scorePanelNumber":"account_scorePanelNumber__Q63Xs","scorePanelTitle":"account_scorePanelTitle__O-nQr"};